import { useEffect, useState } from 'react';



/**
 * Hook to get Users IP, using the Ipify service.
 *
 * @returns {{
 *   ipAddress: string | null
 * }}
 */
const useUserIpAddress = () => {
    const [ipAddress, setIpAddress] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchIp = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                setIpAddress(data.ip);
            } catch (err) {
                console.error('Error fetching IP address:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchIp();
    }, []);


    return {
        ipAddress,
        isLoading,
    };
};



export default useUserIpAddress;
